// extracted by mini-css-extract-plugin
export default {"productDescription":"Uaa-z","featuredDescription":"Vaa-z","description":"Waa-z","more":"Xaa-z","descriptionSku":"Yaa-z"};